type ObjectPayCoverageParams = {
    objectPrice?: number | null;
    objectPriceRate?: number | null;
    paidUsd?: number | null;
    paidUah?: number | null;
    /** Курс з налаштувань (UAH за 1 USD). 1 = режим гривні. */
    rate?: number | null;
};

/** Скільки оплачено відносно вартості об'єкта (0…∞). */
export const getObjectPaymentsCoverageRatio = (params: ObjectPayCoverageParams): number => {
    const objectPrice = Number(params.objectPrice || 0);
    const objectPriceRate = Number(params.objectPriceRate || 0);
    const paidUsd = Number(params.paidUsd || 0);
    const paidUah = Number(params.paidUah || 0);
    const settingsRate = Number(params.rate || 0) || 1;

    if (objectPrice <= 0) return 0;

    if (settingsRate > 1) {
        const fx =
            objectPrice > 0 && objectPriceRate > 0
                ? objectPriceRate / objectPrice
                : settingsRate;
        const paidUsdEq = paidUsd + (fx > 0 ? paidUah / fx : 0);
        return paidUsdEq / objectPrice;
    }

    return (paidUah + paidUsd) / objectPrice;
};

/**
 * Перевіряє, чи оплати документів покривають вартість об'єкта в USD-еквіваленті.
 * Оплати сумуються: paidUsd + paidUah / rate.
 * Вартість об'єкта: USD і UAH — еквіваленти (не сумуються).
 */
export const isObjectPaymentsCovered = (params: ObjectPayCoverageParams): boolean =>
    getObjectPaymentsCoverageRatio(params) + 1e-9 >= 1;

export const getObjectPayStatusVariant = (status: number): string => {
    if (status === 2) return 'success';
    if (status === 1) return 'warning';
    return 'danger';
};
